import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl = 'https://api.futuroacs.com.br/api';
  private tokenKey = 'token';
  constructor(private http: HttpClient, private router: Router)  { }
  //metood para login
  login(credentials: { email: string; password: string }): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/signin`, credentials).pipe(
      tap((res) => {
        if (res && res.token) {
          localStorage.setItem(this.tokenKey, res.token); // Armazena o token
          localStorage.setItem('name', res.user.name);
          localStorage.setItem('picture', res.user.picture);
          localStorage.setItem('id', res.user.id);
          localStorage.setItem('email', res.user.email);
          localStorage.setItem('phone', res.user.phone);
          localStorage.setItem('address', res.user.address);
          localStorage.setItem('district', res.user.district);
          localStorage.setItem('city', res.user.city);
          localStorage.setItem('UF', res.user.UF);
          localStorage.setItem('CEP', res.user.CEP);
        }
      })
    );
  }

  signup(userData: {
    name: string;
    email: string;
    password: string;
    phone?: string;
    address?: string;
    district?: string;
    city?: string;
    UF?: string;
    CEP?: string;
    picture?: string;
    birth?: string;
    status?: boolean;
    plan?: string;
  }): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/signup`, userData).pipe(
      tap((res) => {
        if (res && res.user) {
          // Redireciona para a página de login após o cadastro
          this.router.navigate(['/login']);
        }
      })
    );
  }

  isLoggedIn(): boolean {
    const token = localStorage.getItem(this.tokenKey);
    return !!token;
  }


  logout(): void {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${localStorage.getItem('token')}` 
    });

      //LOGOUT BD
      this.http.post(`${this.apiUrl}/logout/${localStorage.getItem('id')}`, { headers }).subscribe({
      next: () => {
      //logout localmente
        localStorage.removeItem(this.tokenKey);
        localStorage.clear();
        this.router.navigate(['/login']); 
      },
      error: (err) => console.error('Erro ao encerrar a sessão', err)
    });
  }
}
